import { createSelector } from '@ngrx/store';
import { MenusState } from './menus.store';

/**
 * Feature selector for the menus state
 * Manually select from the root state to handle lazy-loaded features
 */
export const selectMenusState = createSelector(
  (state: any) => state?.menus as MenusState,
  (menusState) => menusState,
);
